export default __webpack_public_path__ + "bb2c6fa1dea3adcc77881d22082409e7.png";